























import { defineComponent } from '@vue/composition-api'
import ChromeTip from '@/components/chrome-tip.vue'
import { isInNoxus } from '@shared/plugins/noxus-js-bridge'

export default defineComponent({
  inheritAttrs: false,
  components: {
    ChromeTip,
  },
  setup() {
    return {
      isInNoxus,
    }
  },
})
